module.exports = __webpack_public_path__ + "img/pr-38.824c536b.png";